import { createAsyncThunk } from '@reduxjs/toolkit';
import { FinancialSettingsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  ICreateCashRegisterDTO,
  IEditCashRegisterDTO,
  IGetCashRegisterResponse,
  IGetCashRegistersDTO,
  IGetCashRegistersResponse,
} from '@/models/financialSettings.model';
import { FINANCIAL_SETTINGS_SLICE_NAME } from './models';

export const getCashRegisters = createAsyncThunk<
  IGetCashRegistersResponse,
  IGetCashRegistersDTO,
  { serializedErrorType: IApiError }
>(
  `${FINANCIAL_SETTINGS_SLICE_NAME}/getCashRegisters`,
  async (data) => {
    const response = await FinancialSettingsAPI.getCashRegisters(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getCashRegister = createAsyncThunk<IGetCashRegisterResponse, string, { serializedErrorType: IApiError }>(
  `${FINANCIAL_SETTINGS_SLICE_NAME}/getCashRegister`,
  async (id) => {
    const response = await FinancialSettingsAPI.getCashRegister(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createCashRegister = createAsyncThunk<
  IGetCashRegisterResponse,
  ICreateCashRegisterDTO,
  { serializedErrorType: IApiError }
>(
  `${FINANCIAL_SETTINGS_SLICE_NAME}/createCashRegister`,
  async (data) => {
    const response = await FinancialSettingsAPI.createCashRegister(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateCashRegister = createAsyncThunk<
  IGetCashRegisterResponse,
  IEditCashRegisterDTO,
  { serializedErrorType: IApiError }
>(
  `${FINANCIAL_SETTINGS_SLICE_NAME}/updateCashRegister`,
  async (data) => {
    const response = await FinancialSettingsAPI.updateCashRegister(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteCashRegister = createAsyncThunk<
  IGetCashRegisterResponse,
  string,
  { serializedErrorType: IApiError }
>(
  `${FINANCIAL_SETTINGS_SLICE_NAME}/deleteCashRegister`,
  async (id) => {
    const response = await FinancialSettingsAPI.deleteCashRegister(id);
    return response.data;
  },
  { serializeError: formatApiError },
);
